//import './modules/bootstrap.modules.js';
import mobileNav from './modules/mobileNav';
import accessibleMenu from './modules/accesibleMenu';
import scrolled from './modules/scrolled';
import backToTop from './modules/backToTop';
import { initDeviceDetector } from './modules/deviceDetector';
import ticketsQuantityhandler from './modules/ticketsQuantityHandler';

function initModules() {
	mobileNav();
	accessibleMenu();
	scrolled();
	backToTop();
	initDeviceDetector();
}

function cleanTypes() {
	document.querySelectorAll('script, style').forEach((el) => {
		el.removeAttribute('type');
	});
}

document.addEventListener('DOMContentLoaded', () => {
	initModules();
	cleanTypes();

	ticketsQuantityhandler();

	// Lazy-load slider only if needed
	// if (document.querySelector('.slider')) {
	//   import('./components/tinySlider').then((module) => module.default());
	// }

	// smoothScroll() could be lazy-loaded similarly

	// Traduction du bouton 'upload a file' du tunnel d'inscription
	const buttons = document.querySelectorAll('.thwcfe-btn-file-upload');
	if (buttons) {
		buttons.forEach((button) => {
			if (button.textContent.trim() === 'Upload a File') {
				button.textContent = 'Je choisis mon fichier';
			}
		});
	}

	// Traduction du bouton 'Obtenir Billets' dans la page d'examen
	const examInscriptions = document.querySelector(
		'#tribe-tickets__tickets-submit'
	);
	if (examInscriptions) {
		if (examInscriptions.textContent.trim() === 'Obtenir Billets') {
			examInscriptions.textContent = "S'inscrire";
		}
	}

	// Supprime un des 2 tableaux de review-order dns le dernier step d'inscription
	const $orderReview = document.querySelector('.custom-review-order-before');

	if ($orderReview) {
		$orderReview.classList.add('hide');
	}

	// document.addEventListener('tribe_dialog_show_ar_modal', function () {
	// 	// Cible le contenu et le modifie
	// 	const modal = document.querySelector('.tribe-dialog__content');
	// 	const heading = modal.querySelector('h2');
	// 	if (heading) {
	// 		heading.innerText = 'Titre personnalisé';
	// 	}
	// });
});
